<template>
  <div class="container">
    <dingbu></dingbu>
    <div class="home_content">
      <div
        class="bg_color"
        :style="{
          background:
            'url(' +
            require('../../assets/img/' + bei_ing) +
            ') no-repeat center center',
          'background-size': '100% 100%',
        }"
      >
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">行业网站</span>
            </div>
          </div>
        </div>
        <div class="box-contentm">
          <div class="box-lonm">
            <div class="box-tospl" v-for="(item, index) in addki" :key="index">
              <a :href="item.url" class="atioa" target="_blank">
                <img class="tou_img" :src="item.image" alt />
                <div class="tou-text">{{ item.name }}</div>
              </a>
            </div>
          </div>
        </div>
        <dibu></dibu>
        <daohan></daohan>
      </div>
    </div>
  </div>
</template>


<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu
  },
  data() {
    return {
      addki: [],
      bei_ing: this.Public.bei_ing,
    };
  },
  mounted() {
    this.getcentert();
  },
  methods: {
    //点击跳转到课程详情页
    todolist() {
      this.$router.push({ path: "/details" });
    },
    //系统中心接口
    getcentert() {
      let that = this;
      var url = "index/center";
      let param = {};
      this.post(url)
        .then((res) => {
          this.addki = res.data;
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import "../../css/system.css";
</style>